<template>
  <FormGroup
    :label="label"
    :inputId="id"
    :errors="errorsCalc"
    :successes="successes"
    class="form-radio"
    label-class="form-radio-label"
  >
    <template #radio>
      <input
        type="radio"
        :id="id"
        :checked="checked"
        @change="emitChange"
        class="form-radio-input"
        :value="value"
        :disabled="disabled"
        :name="name"
      />
    </template>
  </FormGroup>
</template>

<script>
import FormGroup from "@/components/display/form/FormGroup";
import FormMixin from "@/components/display/form/FormMixin";

export default {
  name: "FormRadio",
  mixins: [FormMixin],
  components: {
    FormGroup,
  },
  props: {
    name: String,
    value: [Boolean, Number, String],
    checked: Boolean,
  },
  setup(props, { emit }) {
    const emitChange = (e) => {
      emit("input", { checked: e.target.checked, name: props.name, value: e.target.value });
      emit("change", { checked: e.target.checked, name: props.name, value: e.target.value });
    };
    return { emitChange };
  },
};
</script>
